export default "__VITE_ASSET__B6$H3cDI__"